// Class: starling.extensions.PDParticle

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_extensions_Particle() {return require("./../../starling/extensions/Particle");}
function starling_extensions_ColorArgb() {return require("./../../starling/extensions/ColorArgb");}

// Constructor

var PDParticle = function() {
	(starling_extensions_Particle().default).call(this);
	this.colorArgb = new (starling_extensions_ColorArgb().default)();
	this.colorArgbDelta = new (starling_extensions_ColorArgb().default)();
}

// Meta

PDParticle.__name__ = ["starling","extensions","PDParticle"];
PDParticle.__super__ = (starling_extensions_Particle().default);
PDParticle.prototype = $extend((starling_extensions_Particle().default).prototype, {
	
});
PDParticle.prototype.__class__ = PDParticle.prototype.constructor = $hxClasses["starling.extensions.PDParticle"] = PDParticle;

// Init



// Statics




// Export

exports.default = PDParticle;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/extensions/PDParticle.js
// module id = 195
// module chunks = 0